// store.js
import { configureStore } from "@reduxjs/toolkit";
import pdfDataReducer from "./counterSlice"; // Import the reducer

export default configureStore({
  reducer: {
    pdfData: pdfDataReducer, // Use the reducer here
  },
});
